import React from 'react';
import { CardProps } from '../Card/Card';
import { GlassCard } from '@/components/GlassCard/GlassCard';

// Using type alias instead of empty interface to satisfy ESLint
export type DailyChallengeCardProps = Omit<CardProps, 'color'>;

export const DailyChallengeCard: React.FC<DailyChallengeCardProps> = ({
  className = '',
  children,
  ...props
}) => {
  return (
    <GlassCard tone="daily" className={className} {...props}>
      {children}
    </GlassCard>
  );
};
